import ActionWrapper from "modules/MemberList/ActionWrapper";
import TableWrapper, {
  TableWrapperProps,
} from "modules/MemberList/TableWrapper";

import Button from "components/Button";
import { UserAddIcon } from "components/icons";
import { FieldAddress, FieldText } from "components/Table/Field";
import FieldActionIcon from "components/Table/Field/FieldActionIcon";
import { ActionType } from "components/Table/Field/FieldActionList";
import Filter from "../Filter";

import { useTranslationContext } from "context/TranslationContext";

import { TFinalSort, TTableRecord } from "components/Table/types";
import { TEmployeeFilter } from "modules/MemberList/types";

interface BUUnassignedMemberListProps extends TableWrapperProps {
  sort?: Record<string, TFinalSort>;
  actionList?: ActionType[];
  filter?: Partial<TEmployeeFilter>;
  onClickAction?: (record: TTableRecord, actionType: string) => void;
  onFilter?: (filter: Partial<TEmployeeFilter>) => void;
  onSearch?: (keyword: string) => void;
  isRowSelected?: boolean;
  onClickAssignAccountBtn?: () => void;
  hasAssignStaffAccess?: boolean;
}

const BUUnassignedMemberList = ({
  sort,
  actionList,
  filter,
  onClickAction,
  onFilter,
  onSearch,
  isRowSelected,
  onClickAssignAccountBtn,
  hasAssignStaffAccess,
  ...rest
}: BUUnassignedMemberListProps) => {
  const { t } = useTranslationContext();

  return (
    <TableWrapper
      {...rest}
      action={
        hasAssignStaffAccess && isRowSelected ? (
          <Button
            color="primary"
            onClick={onClickAssignAccountBtn}
            className="flex min-w-[11.5rem] my-1 ml-auto"
            leftIcon={<UserAddIcon width={18} height={18} />}
          >
            {t("assign_account")}
          </Button>
        ) : (
          <ActionWrapper keyword={filter?.keyword} onSearch={onSearch}>
            <Filter filter={filter} onFilter={onFilter} />
          </ActionWrapper>
        )
      }
      fields={[
        {
          title: t("name"),
          key: "name",
          width: "16%",
          imageKey: "profilePicture",
          imageLabelKey: "name",
          sort: sort?.["name"],
          withImage: true,
          isPersonalPicture: true,
          blacklistLabelKey: "blacklistStatus.isBlacklisted",
          accountTypeKey: "memberType",
          component: FieldText,
        },
        {
          title: t("account_type"),
          key: "memberType",
          width: "12%",
          sort: sort?.["memberType"],
          component: FieldText,
        },
        {
          title: t("id"),
          key: "idMember",
          width: "15%",
          sort: sort?.["idMember"],
          component: FieldText,
        },
        {
          title: t("phone_number"),
          key: "strPhoneNumber",
          width: "14%",
          component: FieldText,
        },
        {
          title: t("email"),
          key: "email",
          width: "17%",
          component: FieldText,
        },
        {
          title: t("address"),
          key: "address",
          width: "18%",
          component: FieldAddress,
        },

        {
          title: t("assign_account"),
          key: "action_list",
          width: "9%",
          actions: actionList,
          headerClassName: "text-center w-full",
          onClick: onClickAction,
          icon: (
            <div className="w-[30px] h-[30px] bg-primary-50 rounded-md flex items-center justify-center cursor-pointer">
              <UserAddIcon
                width={18}
                height={18}
                className="text-primary-500"
              />
            </div>
          ),
          component: FieldActionIcon,
        },
      ]}
    />
  );
};

export default BUUnassignedMemberList;
